import './App.css'
import Hooksapi from './components/Hooksapi';

function App() {
  return (
    <div className="App">
      <Hooksapi />
    </div>
  );
}

export default App;
